import { Card } from '../../components/core/Card.jsx'
import { AdminLayout, Table } from '../../admin/AdminLayout.jsx'

// The latest collection runs, with what each engine did — so a provider
// running dry or failing shows up here as a column of failures rather than
// as a quiet week on somebody's dashboard.
export default function AdminRuns({ runs = [] }) {
  const rows = runs.map((r) => ({
    ...r,
    where: (
      <span>
        {r.business}
        <br />
        <span className="text-[color:var(--text-muted)]">{r.account}</span>
      </span>
    ),
    engines_cell: (
      <span className="flex flex-col gap-0.5 font-mono text-[12px]">
        {r.engines.map((e) => (
          <span key={e.engine}>
            {e.engine}: {Object.entries(e.statuses).map(([s, n]) => `${n} ${s}`).join(', ')}
          </span>
        ))}
      </span>
    ),
  }))

  return (
    <AdminLayout title="Runs">
      <Card pad="md">
        <Table
          columns={[
            ['id', 'Run', 'right'], ['where', 'Business'], ['trigger', 'Trigger'], ['status', 'Status'],
            ['engines_cell', 'By engine'], ['cost', 'Cost', 'right'], ['started', 'Started'], ['finished', 'Settled'],
          ]}
          rows={rows}
          empty="No runs yet."
        />
      </Card>
    </AdminLayout>
  )
}
